import React, { useEffect } from "react";
import AudioPlayer from "react-h5-audio-player";
// import "react-h5-audio-player/lib/styles.css";
import "./Player.css";
const Player = () => {
  useEffect(() => {
    var tag = document.createElement("p");
    var text = document.createTextNode("Surat Al Fath (Tilawat & Translation)");
    var arText = document.createTextNode("سورة الفتح (تلاوات وترجمة)");
    var frText = document.createTextNode(
      "Sourate Al Fath (Tilawat et traduction)"
    );
    var rtl = document.querySelector("body").getAttribute("class");
    console.log(rtl);
    // rtl ? (rtl.includes("rtl") ? setRtl(true) : setRtl(false)) : null;
    if (localStorage.getItem("Language") == "rtl") {
      tag.appendChild(arText);
    } else if (localStorage.getItem("Language") == "fr") {
      tag.appendChild(frText);
    } else {
      tag.appendChild(text);
    }

    var element = document.querySelector(".rhap_stacked");
    element.appendChild(tag);
  }, []);


  return (
    <AudioPlayer
      src={require("../../Assets/Quran.mp3")}
      onPlay={(e) => console.log("onPlay")}
    />
  );
};

export default Player;
